import { useDispatch, useSelector } from 'react-redux';

import { getLicenseModal } from '../selectors/user';
import { changeLicenseModal } from '../actions/user';
import useFetch from './useFetch';
import Api from '../api';

const useLicense = () => {
  const dispatch = useDispatch();
  const licenseModalMode = useSelector(getLicenseModal());

  const { onSubmit, loading: pending } = useFetch('license', Api.LICENSE);

  const handleChangeModalMode = (mode) => dispatch(changeLicenseModal(mode));

  return {
    mode: licenseModalMode,
    pending,
    saveCode: onSubmit,
    changeMode: handleChangeModalMode,
  };
};

export default useLicense;
